import type { RecoveryMeasure } from "@/api/enrichment";
import { cn } from "@/lib/utils";

interface RecoveryRingProps {
  label: string;
  measure: RecoveryMeasure;
  tone: string;
}

export function RecoveryRing({ label, measure, tone }: RecoveryRingProps) {
  const percentage = measure.percentage;
  const circumference = 2 * Math.PI * 42;
  return (
    <div className="rounded-xl bg-slate-50/70 px-3 py-4 text-center" data-recovery-ring={label}>
      <div className="relative mx-auto h-28 w-28">
        <svg className={cn("h-full w-full -rotate-90", tone)} viewBox="0 0 100 100" aria-hidden="true">
          <circle cx="50" cy="50" r="42" fill="none" stroke="currentColor" strokeWidth="8" className="text-slate-200" />
          {percentage !== null && percentage > 0 && <circle
            cx="50" cy="50" r="42" fill="none" stroke="currentColor" strokeWidth="8"
            strokeDasharray={`${circumference * percentage / 100} ${circumference}`}
          />}
        </svg>
        <div className="absolute inset-0 flex items-center justify-center text-2xl font-semibold tabular-nums text-slate-900">
          {percentage === null ? "n/a" : `${percentage.toLocaleString("en-US", { maximumFractionDigits: 1 })}%`}
        </div>
      </div>
      <p className="mt-2 text-sm font-medium text-slate-900">{label}</p>
      <p className="mt-1 text-xs tabular-nums text-slate-500">{measure.count.toLocaleString("en-US")} {measure.count === 1 ? "record" : "records"}</p>
    </div>
  );
}
